import React, { lazy } from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';

const NotFound = lazy(() => import('../../container/pages/404'));
const VehicleLicense = lazy(() => import('../../container/license/vehicle-license'));

function MaintenanceRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/vehicle-license`} component={VehicleLicense} />
      <Route exact path={`${path}`}>
        <Redirect to={`${path}/vehicle-license`} />
      </Route>
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  );
}

export default MaintenanceRoutes;
